import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainerS0,
    GridItem2xs12,
    GridItem3xs12,
    GridItem8xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    ButtonVisualizarEstrategiasFinanceiras,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    CustomizedDialogsPopupParametros,
    CustomizedDialogsPopupHipotesesFinanceiras,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraComp'

import {
    CustomizedDialogsPopupComparacaoCenarios,
    CustomizedDialogsPopupComparacaoEstudos,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompHipotesesFinanceiras'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import CarteiraInvestimentosChart from '../estudo-chart/CarteiraInvestimentosChart'

import DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart from '../estudo-chart/DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart'

import EstudoFormResumoSeguroVidaCotacao from '../estudo-form/EstudoFormResumoSeguroVidaCotacao'

import EstudoFormTabelaEvolucaoValorResgate from '../estudo-form/EstudoFormTabelaEvolucaoValorResgate'

import EstudoFormTabelaEvolucaoCS from '../estudo-form/EstudoFormTabelaEvolucaoCS'

import EstudoFormTabelaEvolucaoCancelamentoApolice from '../estudo-form/EstudoFormTabelaEvolucaoCancelamentoApolice'

import TabelaEvolucaoValorResgateChart from '../estudo-chart/TabelaEvolucaoValorResgateChart'

import AnaliseInvestimentoVersusSeguroVidaInteiraChart from '../estudo-chart/AnaliseInvestimentoVersusSeguroVidaInteiraChart'

import AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart from '../estudo-chart/AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart'

import SimulacaoFinanceiraFormEvolucaoReservaFinanceira from '../simulacaoFinanceira-form/SimulacaoFinanceiraFormEvolucaoReservaFinanceira'



const EstudoFormPatrimonialProjecaoFutura = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    estudo, vars, linhaFormList}) => {
        
    const GridItemProjecaoFutura = values.jsonComparacaoEstudos.estudos.length > 1 ? GridItem12 : GridItem8xs12

    const GridItemProjecaoFuturaDialogs = values.jsonComparacaoEstudos.estudos.length > 1 ? GridItem2xs12 : GridItem3xs12

    return (
        <div>
            <GridContainerS0
                className='justify-center'
            >
                <GridItemProjecaoFutura
                    className='mt-2 mb-2'
                >
                    <CardGridEntradaDados>
                        <CardGridDivBodyEntradaDados>
                            <GridContainerS0
                                className='mt-2 justify-center'
                            >
                                <GridItemProjecaoFuturaDialogs
                                    className='mb-2'
                                >
                                    <CustomizedDialogsPopupParametros
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        setFieldValue={setFieldValue}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        vars={vars}
                                    />
                                </GridItemProjecaoFuturaDialogs>
                                <GridItemProjecaoFuturaDialogs
                                    className='mb-2'
                                >
                                    <CustomizedDialogsPopupHipotesesFinanceiras
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmit={handleSubmit}
                                        setFieldValue={setFieldValue}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        vars={vars}
                                        linhaFormList={linhaFormList}
                                    />
                                </GridItemProjecaoFuturaDialogs>
                                <GridItemProjecaoFuturaDialogs
                                    className='mb-2'
                                >
                                    <CustomizedDialogsPopupComparacaoCenarios
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        linhaTipoLicenca={vars.linhaTipoLicenca}
                                        jsonConfiguracao={vars.jsonConfiguracao}
                                        jsonPagina={vars.jsonPagina}
                                        jsonUsuario={vars.jsonUsuario}
                                        jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    />
                                </GridItemProjecaoFuturaDialogs>
                                {values.jsonComparacaoEstudos.estudos.length > 1 && (
                                    <GridItemProjecaoFuturaDialogs
                                        className='mb-2'
                                    >
                                        <CustomizedDialogsPopupComparacaoEstudos
                                            variaveisGlobais={variaveisGlobais}
                                            values={values}
                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                            estudo={estudo}
                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                            jsonPagina={vars.jsonPagina}
                                            jsonUsuario={vars.jsonUsuario}
                                            jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                        />
                                    </GridItemProjecaoFuturaDialogs>
                                )}
                                {existeTabelaEvolucaoValorResgate(values) && (
                                    <CustomizedDialogsPopup
                                        maxWidth='lg'
                                        popupTitle={LABEL.gestaoPatrimonialEstrategiasFinanceiras}
                                        PopupButton={ButtonVisualizarEstrategiasFinanceiras}
                                        popupComponent={
                                            <>
                                                <CarteiraInvestimentosChart
                                                    values={values}
                                                    estudo={estudo}
                                                    report={false}
                                                    popup={true}
                                                    simulacaoFinanceira={true}
                                                />
                                                
                                                {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras
                                                .filter(item => !item.utilizarApenasComparacaoPreco)?.map( (cotacao, indCotacao) => (
                                                    <div
                                                        key={indCotacao}
                                                    >
                                                        {values.exibirResumoSeguroVidaCotacao && (
                                                            <EstudoFormResumoSeguroVidaCotacao
                                                                values={values}
                                                                estrategiasFinanceirasTabelaEvolucaoValorResgateSeguradoras={cotacao}
                                                                utilizarApenasComparacaoPreco={false}
                                                                report={false}
                                                            />
                                                        )}

                                                        {estudo.current.estrategiasFinanceirasTabelaEvolucaoValorResgate
                                                        .filter(item => !item.utilizarApenasComparacaoPreco &&
                                                        item.seguradora === cotacao.id)?.map( (item, ind) => (
                                                            <div
                                                                key={ind}
                                                            >
                                                                {!values.exibirTabelaEvolucaoCS && !values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                                    <EstudoFormTabelaEvolucaoValorResgate
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                    />
                                                                )}
                                                                {values.exibirTabelaEvolucaoCS && (
                                                                    <EstudoFormTabelaEvolucaoCS
                                                                        values={values}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                    />
                                                                )}
                                                                {values.exibirTabelaEvolucaoCancelamentoApolice && (
                                                                    <EstudoFormTabelaEvolucaoCancelamentoApolice
                                                                        values={values}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                    />
                                                                )}
                                                                {(values.exibirTabelaEvolucaoCS ||
                                                                values.exibirTabelaEvolucaoCancelamentoApolice) && (
                                                                    <TabelaEvolucaoValorResgateChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                        tabelaEvolucaoValorResgate={false}
                                                                    />
                                                                )}
                                                                {values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira &&
                                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                                    <AnaliseInvestimentoVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                    />
                                                                )}
                                                                {values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira &&
                                                                !item.apenasExibirTabelaEvolucaoValorResgateSemTaxaInflacao && (
                                                                    <AnalisePrevidenciaPrivadaVersusSeguroVidaInteiraChart
                                                                        values={values}
                                                                        estudo={estudo}
                                                                        estrategiasFinanceirasTabelaEvolucaoValorResgate={item}
                                                                        report={false}
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </>
                                        }
                                    />
                                )}
                            </GridContainerS0>
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </GridItemProjecaoFutura>
            </GridContainerS0>

            <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart
                values={values}
                setFieldValue={setFieldValue}
                estudo={estudo}
                report={false}
                popup={false}
            />

            <SimulacaoFinanceiraFormEvolucaoReservaFinanceira
                values={values}
                estudo={estudo}
                popup={false}
            />
        </div>
    )
}

export default EstudoFormPatrimonialProjecaoFutura